export const CustomerFields: Array<string> = [
  'phone',
  'corporatePhone',
  'stateInscription',
]

export const ProfileFields: Record<string, string> = {
  phone: 'homePhone',
  corporatePhone: 'businessPhone',
  stateInscription: 'stateRegistration',
}

export const FormFields: Record<string, Array<string>> = {
  personal: ['email', 'document', 'firstName', 'lastName', 'homePhone'],
  business: [
    'corporateName',
    'corporateDocument',
    'businessPhone',
    'stateRegistration',
    'tradeName',
  ],
}
